/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Your_3Inputs */



/**
* | output |
* | --- |
* | "Implementation of supplementary organizational measures" |
*
* @param {Guardrails_Section_3_Your_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_your_3 = /** @type {((inputs?: Guardrails_Section_3_Your_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Your_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Implementierung ergänzender organisatorischer Maßnahmen")
	return /** @type {LocalizedString} */ ("Implementation of supplementary organizational measures")
});